export default function WhySpecialized() {
  const painPoints = [
    {
      title: 'Generic bookkeepers miss your industry nuances',
      desc: 'Most bookkeepers treat a restaurant like any other small business. They do not understand tipped payroll complexities, prime cost tracking, or POS integrations like Toast and Square.',
    },
    {
      title: 'Trades bookkeeping requires job-costing expertise',
      desc: 'Contractors need change order tracking, retainage accounting, and project-level profitability reports — not just monthly P&L summaries that hide which jobs actually made money.',
    },
    {
      title: 'Reactive reporting costs you money',
      desc: 'Waiting until year-end to discover cash flow problems, pricing leaks, or tax surprises means missed opportunities and preventable penalties. You need proactive monthly insights.',
    },
    {
      title: 'National firms lack local Virginia context',
      desc: 'Remote bookkeepers who have never stepped into a Richmond kitchen or a Henrico job site cannot anticipate the seasonal, regulatory, and market realities you face every day.',
    },
  ];

  return (
    <section id="why-specialized" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
              Why Specialization Matters
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-950 max-w-3xl mx-auto leading-tight">
              The Cost of a
              <span className="italic text-accent-600"> One-Size-Fits-All </span>
              Bookkeeper
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
            {painPoints.map((point, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60 hover:border-accent-300/40 transition-colors"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-error-warning-line text-accent-600 text-lg" />
                  </div>
                  <div>
                    <h3 className="font-heading text-lg md:text-xl text-primary-950 font-semibold mb-2">
                      {point.title}
                    </h3>
                    <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                      {point.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto mb-6">
              We built Penland Bookkeeping specifically to solve these problems for
              restaurants, trades, small businesses, and nonprofits in the Richmond area.
              No more explaining your business to someone who does not get it.
            </p>
            <a
              href="#services"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 text-accent-600 hover:text-accent-500 font-semibold text-sm transition-colors"
            >
              See How We Solve Them
              <i className="ri-arrow-down-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}